<template>
  <section class="relative flex items-center justify-center overflow-hidden">
    <!-- 배경 영역 -->
    <div class="absolute inset-0 h-auto bg-slate-50 p-3 pb-0 pt-6 lg:px-[60px] lg:pt-8">
      <OptimizedImage
        :base-path="backgroundImage.basePath"
        :file-name="backgroundImage.fileName"
        alt="background image"
        image-class="size-full rounded-[30px] object-cover object-center lg:rounded-[60px]"
      />
    </div>

    <!-- 콘텐츠 영역 -->
    <div
      data-aos="fade-up"
      data-aos-anchor="#aos-section6"
      class="gn-container z-10 flex w-full flex-col items-center gap-4 p-6 pt-24 lg:w-4/5 lg:flex-row lg:px-10 xl:px-16 2xl:px-[110px]"
    >
      <div
        class="flex flex-col items-center gap-3 text-center text-white lg:flex-1 lg:items-start lg:gap-7 lg:text-start"
      >
        <div class="flex flex-col gap-2 lg:gap-3">
          <h3 class="gn-text-xl font-bold">{{ subTitle }}</h3>
          <h1 class="gn-text-3xl font-extrabold">{{ title }}</h1>
        </div>
        <p class="gn-text-xl font-normal leading-relaxed lg:max-w-[500px]">
          {{ context }}
        </p>

        <Button
          v-if="buttonText"
          size="lg"
          color="blue"
          round
          class="hidden lg:block"
          @click="navigateTo(localeRoute('/dr-rodin'))"
        >
          {{ buttonText }}
        </Button>
      </div>

      <div class="flex-shrink-0 lg:mt-0">
        <OptimizedImage
          :base-path="introImage.basePath"
          :file-name="introImage.fileName"
          alt="intro image"
          image-class="size-52 lg:size-[420px]"
          :localized="introImage.localized"
        />
      </div>

      <Button
        v-if="buttonText"
        size="lg"
        color="blue"
        round
        class="block lg:hidden"
        @click="navigateTo(localeRoute('/dr-rodin'))"
      >
        {{ buttonText }}
      </Button>
    </div>
  </section>
</template>

<script setup>
import OptimizedImage from '~/components/common/OptimizedImage.vue'
import Button from '~/components/common/Button.vue'

defineProps({
  backgroundImage: {
    type: Object,
    required: true,
    default: () => ({
      basePath: '',
      fileName: ''
    })
  },
  introImage: {
    type: Object,
    required: true,
    default: () => ({
      basePath: '',
      fileName: '',
      localized: false
    })
  },
  buttonText: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    required: true
  },
  subTitle: {
    type: String,
    required: true
  },
  context: {
    type: String,
    required: true
  }
})

const localeRoute = useLocaleRoute()
</script>
